import React from 'react'

const AutoLogout = ({onConfirm}) => {
  return (
    <>
     <div className="modal-wrapper">
   
    <div className="logout-confirm">
        <h3 className=" font-semibold mb-4">Session Expired</h3>
        <p className="mb-6">Your session has expired. Please login again.</p>
         <div className="bottom-buttons">
        <button
          onClick={onConfirm}
          className="yes"
        >
          OK
        </button>
        </div>
      </div>
    </div>
    </>
  )
}


export default AutoLogout